const routes = {
	home: '/',
	login: '/dang-nhap',
	register: '/dang-ky',
	dashboard: '/dashboard',
	profile: '/tai-khoan',
	settings: '/settings',
	notFound: '/404',
	terms: '/terms',
	serverError: '/500',
	tourTrongNuoc: '/tour-trong-nuoc',
	tourNgoaiNuoc: '/tour-nuoc-ngoai',
	tourDetail: '/tour-chi-tiet/',
	contacts: '/lien-he',
	about: '/gioi-thieu',
	booking: '/dat-tour/',
	bookedTour: '/dat-tour/thanhcong',
	historyBooked: '/lich-su-dat-tour',
	historyPayment: '/lich-su-thanh-toan',
	forgotPassword: '/quen-mat-khau',
	changePassword: '/doi-mat-khau',
	blogMienBac: '/MienBac',
	blogMienTrung: '/MienTrung',
	blogMienNam: '/MienNam',
	adminHome: '/admin',
	news: '/news/',
	checkOutSuccess: '/checkout/success/',
	checkoutFail: '/checkout/fail/',
	infoBlog: '/info-blog',
	oauth2: '/oauth2/',
	oauth2Redirect: '/oauth2/redirect/',
	redirectBooking: '/booking/',
};

export default routes;
